export function isDealerVerified(dealer: { verified?: boolean | null; risco_verified?: boolean | null; verification_status?: string | null } | null | undefined): boolean {
  return dealer?.verified === true || dealer?.risco_verified === true || dealer?.verification_status === 'verified';
}